module.exports = __webpack_public_path__ + "img/3.1d742077.jpg";